<!-- 
  

<div class="Dialog-body">
  <div class="modal-header">
    
    <div class="sc-badge sc-safe" style="padding: 4px 3px !important;">Modify Photo</div>
</div>
  <form>
   

    <div >
                  
      <img  id="QuestionId" style='display:block; width: 250px;' *ngIf="QuestionImage" [src]="sanitize(QuestionImage)"  />    

     
      
</div>
   
      <div class="buttonbelow">
        <button mat-button  >Submit</button>
        <button mat-button  (click)="DialogClose()" >Cancel</button>    
      </div>
  </form>

</div> -->


<div id="edit-photo-main" class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Edit Photo</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick(false)">close</i>
    </div>

    <div class="ttmodal__body" style="min-width: 970px;">
        <div>
            <div id="img-panel" style="width: 80%; float: left; max-height: 650px; overflow: scroll; position: relative">
                <canvas #photoCanvas width=700 height=650 (mouseenter)="mouseEnterCanvas($event)" (mouseleave)="mouseLeaveCanvas($event)"
                        (mousedown)="mouseDownOverCanvas($event)" (mouseup)="mouseUpOverCanvas($event)" (click)="displayTextInput($event)"></canvas>
                <input type="text" id="textInput" (keyup)="enterText($event)"
                       style="min-width: 100px; display:none; position: absolute; font: 20px Roboto; padding: 5px; background: rgba(255, 255, 255, 0.7);
                        border: 1px solid white;" placeholder="Click here to Enter text">
            </div>

            <div id="tools-panel" style="width: 20%; height: 650px; float: right; display: flex; flex-direction: column; padding-left: 10px">
                <div id="tools-select" class="toolsPanelItem">
                    <b>Select Tool</b>

                    <div>
                        <mat-button-toggle-group name="toolForEditing" aria-label="Tool For Editing" vertical="true"
                                                 class="editToolToggleGroup" value="Pencil">
                            <mat-button-toggle value="Pencil" class="editToolToggleHeader" (click)="selectTool('Pencil')">
                                <i class="material-icons button__icon editToolToggleItem">edit</i>
                                <span class="button__text editToolToggleItem">Pencil</span>
                            </mat-button-toggle>
                            <mat-button-toggle value="Arrow" class="editToolToggleHeader" (click)="selectTool('Arrow')">
                                <i class="material-icons button__icon editToolToggleItem">arrow_forward</i>
                                <span class="button__text editToolToggleItem">Arrow</span>
                            </mat-button-toggle>
                            <mat-button-toggle value="Circle" class="editToolToggleHeader" (click)="selectTool('Circle')">
                                <i class="material-icons button__icon editToolToggleItem">radio_button_unchecked</i>
                                <span class="button__text editToolToggleItem">Circle</span>
                            </mat-button-toggle>
                            <mat-button-toggle value="Line" class="editToolToggleHeader" (click)="selectTool('Line')">
                                <i class="material-icons button__icon editToolToggleItem">maximize</i>
                                <span class="button__text editToolToggleItem">Line</span>
                            </mat-button-toggle>
                            <mat-button-toggle value="Text" class="editToolToggleHeader" (click)="selectTool('Text')">
                                <i class="material-icons button__icon editToolToggleItem">text_format</i>
                                <span class="button__text editToolToggleItem">Text</span>
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </div>

                <div id="colour-select" class="toolsPanelItem">
                    <b>Select Colour</b>
                    <mat-button-toggle-group style="display: flex; flex-direction: row; height: 40px; width: 100%;">
                        <mat-button-toggle value="red" style="background-color: red;" (click)="selectColour($event, 'red')">
                            <i class="material-icons" *ngIf="selectedColour == 'red'" style="color: white;">fiber_manual_record</i>
                        </mat-button-toggle>
                        <mat-button-toggle value="black" style="background-color: black;" (click)="selectColour($event, 'black')">
                            <i class="material-icons" *ngIf="selectedColour == 'black'" style="color: white;">fiber_manual_record</i>
                        </mat-button-toggle>
                        <mat-button-toggle value="blue" style="background-color: deepskyblue;" (click)="selectColour($event, 'deepskyblue')">
                            <i class="material-icons" *ngIf="selectedColour == 'deepskyblue'" style="color: white;">fiber_manual_record</i>
                        </mat-button-toggle>
                        <mat-button-toggle value="orange" style="background-color: orange;" (click)="selectColour($event, 'orange')">
                            <i class="material-icons" *ngIf="selectedColour == 'orange'" style="color: white;">fiber_manual_record</i>
                        </mat-button-toggle>
                        <mat-button-toggle value="green" style="background-color: mediumseagreen;" (click)="selectColour($event, 'mediumseagreen')">
                            <i class="material-icons" *ngIf="selectedColour == 'mediumseagreen'" style="color: white;">fiber_manual_record</i>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>

                <div id="rotate-photo" class="toolsPanelItem">
                    <b>Rotate Photo</b>

                    <div style="flex-direction: row;">
                        <a class="button waves-effect" (click)="rotatePhoto('Left')">
                            <i class="material-icons button__icon">rotate_left</i>
                        </a>

                        <a class="button waves-effect" (click)="rotatePhoto('Right')">
                            <i class="material-icons button__icon">rotate_right</i>
                        </a>
                    </div>
                </div>

                <div id="undo-last-action" class="toolsPanelItem">
                    <b>Undo Last Action</b>

                    <div style="flex-direction: row;">
                        <a class="button waves-effect" (click)="undoLastAction()">
                            <i class="material-icons button__icon">undo</i>
                        </a>
                    </div>
                </div>

                <div id="save-changes" class="toolsPanelItem">

                    <div style="flex-direction: row;">
                        <a class="button waves-effect" (click)="onCloseClick(false)">
                            <span class="button__text">Cancel</span>
                        </a>
                        <a class="button button--primary waves-effect" (click)="onCloseClick(true)">
                            <span class="button__text">Save</span>
                        </a>
                    </div>
                </div>

            </div>
        </div>
        <div id="tooltip" style="text-align: center;">
            <span *ngIf="selectedTool == 1">Pencil selected - Click and hold on the canvas to draw.</span>
            <span *ngIf="selectedTool == 2">Arrow selected - Click and hold on the canvas to select the start point. Drag and release the mouse button to select the end point.</span>
            <span *ngIf="selectedTool == 3">Circle selected - Click and hold on the canvas to select the start point. Drag and release the mouse button to set the circle diameter.</span>
            <span *ngIf="selectedTool == 4">Line selected - Click and hold on the canvas to select the start point. Drag and release the mouse button to select the end point.</span>
            <span *ngIf="selectedTool == 5">Text selected - Click on the canvas to display the text box. Press the return key after editing to save.</span>
        </div>
    </div>
</div>
